var swiper = new Swiper(".splashBannerSwiper", {
  effect: 'fade',
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: ".js-splash-banner-swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    enabled: false,
    nextEl: ".js-splash-banner-swiper-button-next",
    prevEl: ".js-splash-banner-swiper-button-prev",
  },
  breakpoints: {
    640: {
      navigation: {
        enabled: false
      }
    },
    768: {
      navigation: {
        enabled: true
      }
    },
    1024: {
      navigation: {
        enabled: true
      }
    },
  },
});